import React, { useState } from 'react';

import Button from '~/components/button';
import SeedProductForm from '~/components/seed/seed-product-form';
import ShippingBadge from '~/components/sunday-store/components/product-details/shipping-badge';
import { formatNumber } from '~/utils/numbers';
import { urlFor } from '~/sanity/images';
import FeatureBadge from '~/components/seed/feature-badge';

import styles from '~/components/seed/seed-finder.module.scss';

const AdditionalRecommendations = ({
  products,
  seedingPurposeContent,
  seedingSquareFootage,
  showAddedToCartModal,
  showProductDetailsModal,
}) => {
  const availableProducts = products?.filter(
    (product) => product.productDetails.inStock === true
  );

  return (
    <section className={styles.additionalRecs}>
      <h2>You may also like</h2>
      <div className={styles.productsContainer}>
        {availableProducts?.map((product) => (
          <ProductBlock
            key={product.sku}
            product={product}
            seedingPurposeContent={seedingPurposeContent}
            seedingSquareFootage={seedingSquareFootage}
            showAddedToCartModal={showAddedToCartModal}
            showProductDetailsModal={showProductDetailsModal}
          />
        ))}
      </div>
    </section>
  );
};

const ProductBlock = ({
  product,
  seedingPurposeContent,
  seedingSquareFootage,
  showAddedToCartModal,
  showProductDetailsModal,
}) => {
  const { features, productDetails, purchaseSku, quantity, seedDescription } =
    product;
  const [qtySelected, setQtySelected] = useState(quantity);

  const handleQtyFieldChange = ({ target }) => {
    setQtySelected(target.value);
  };

  const desktopSource = urlFor(productDetails.primaryImage)
    .width(640)
    .height(640)
    .dpr(2)
    .fit('crop')
    .crop('focalpoint');
  const mobileSource = urlFor(productDetails.primaryImage)
    .width(128)
    .height(128)
    .dpr(2)
    .fit('crop')
    .crop('focalpoint');

  return (
    <div className={styles.productRecCard}>
      <div className={styles.productRecInner}>
        <button
          className={styles.modalTriggerButton}
          onClick={() => showProductDetailsModal(product)}
        >
          <img
            alt={productDetails.primaryImage.alt || ''}
            className={styles.productImg}
            sizes="(max-width: 768px) 256px, 376px"
            srcSet={`${mobileSource.url()} 375w, ${desktopSource.url()}`}
          />
        </button>

        <div className={styles.textContainer}>
          <p className={styles.productTitle}>{productDetails.name}</p>
          <p className={styles.productText}>{seedDescription}</p>
          <Button
            className={styles.learnMoreButton}
            onClick={() => showProductDetailsModal(product)}
            variant="link"
          >
            Learn more
          </Button>
          {features?.[0] && (
            <FeatureBadge
              text={features?.[0]?.text}
              icon={{ src: features?.[0]?.icon, alt: features?.[0]?.alt }}
            />
          )}
        </div>
      </div>

      <div className={styles.productRecLower}>
        <p className={styles.qtyText}>
          For {seedingPurposeContent?.displayText} at{' '}
          <strong>{formatNumber(seedingSquareFootage)} sq ft</strong>, you’ll
          need <strong>{quantity}</strong>.
        </p>

        <div className={styles.addProduct}>
          <SeedProductForm
            onFieldChange={handleQtyFieldChange}
            productDetails={productDetails}
            purchaseSku={purchaseSku}
            quantity={qtySelected}
            afterSubmit={() => showAddedToCartModal(product)}
          />
        </div>

        <div className={styles.shippingBadgeContainer}>
          <ShippingBadge
            productDetails={productDetails}
            purchaseSku={purchaseSku}
          />
        </div>
      </div>
    </div>
  );
};

export default AdditionalRecommendations;
